const config = {
  colors: {
    primary: '#d64933',
    background: "#EDe9D0",
    // background: "#E2E7D7  ",
    // background: '#414E56',
    secondary: '#545e71',
    secondaryContrastText: 'white',
    secondaryBackground: 'white',
    dressCodepalette: [
      "#f9b28e",
      "#FFFCAB",
      "#d64933",
      "#ee7451",
      "#f4a6a1",
      "#acc8d5",
      "#fcd0ab",
      "#EDe9D0"
    ]
  },
  uripaths: {
    thankYouPath: '/dakujeme',
    palenkaPath: '/palenka',
    weddingPartyAfter9PMPath: '/weddingPartyAfter9PM',
  },
};

export default config;